var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "61px",
    viewBox: "0 0 62 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/01",
    transform: "translate(-1.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16021154,24.9233894 L2.04463462,24.358726 C1.64782692,25.8017548 1.36282692,27.2815625 1.18963462,28.7613702 L3.36878846,29.0080048 C3.52663462,27.6363702 3.79409615,26.2625721 4.16021154,24.9233894",
    id: "Fill-1",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5457962,26.3716106 L61.6920654,25.9194471 C61.3741808,24.461274 60.9466808,23.0139183 60.41395,21.6184856 L58.36195,22.3778606 C58.8552192,23.673774 59.2520269,25.0194471 59.5457962,26.3716106",
    id: "Fill-3",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0084346,2.44567308 C35.5242423,2.19038462 34.0049731,2.04110577 32.4900885,2 L32.4352808,4.16346154 C33.84055,4.20024038 35.2523962,4.33870192 36.6313577,4.57668269 L37.0084346,2.44567308 Z",
    id: "Fill-5",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5053269,17.5539904 C57.7687115,16.2494231 56.9268654,14.9902885 56.0082885,13.8133654 L54.2697885,15.1330769 C55.1247885,16.2277885 55.90525,17.3960577 56.5914423,18.6075962 L58.5053269,17.5539904 Z",
    id: "Fill-8",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0171346,11.0203365 L11.5833654,9.38475962 C10.4433654,10.3583173 9.36475,11.4270673 8.38040385,12.5607212 L10.0421731,13.9691346 C10.96075,12.9155288 11.9604423,11.9246635 13.0171346,11.0203365",
    id: "Fill-10",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53855769,17.3186058 L5.68386538,16.1676442 C4.87709615,17.4311058 4.16240385,18.7616346 3.55513462,20.1267788 L5.56328846,20.9986538 C6.12451923,19.7308654 6.79098077,18.4912019 7.53855769,17.3186058",
    id: "Fill-12",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2199115,4.35882212 L27.9590269,2.21050481 C26.4529115,2.39007212 24.9555654,2.68213942 23.5020654,3.07805288 L24.0830269,5.16362981 C25.4334885,4.79584135 26.8256038,4.52540865 28.2199115,4.35882212",
    id: "Fill-14",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9796154,10.4742788 C51.8900385,9.43798077 50.7149615,8.47307692 49.4850769,7.60769231 L48.2135385,9.37091346 C49.3557308,10.1735577 50.4475,11.0670673 51.4603462,12.0319712 L52.9796154,10.4742788 Z",
    id: "Fill-16",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6040346,5.2821875 C44.2579577,4.60502404 42.8483038,4.02088942 41.4123423,3.54709135 L40.7173808,5.59805288 C42.0503038,6.03723558 43.3591115,6.58026442 44.6065346,7.20983173 L45.6040346,5.2821875 Z",
    id: "Fill-18",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1164846,6.5646875 L19.2264077,4.58728365 C17.8430615,5.19521635 16.4991769,5.90699519 15.2254462,6.7053125 L16.4027154,8.53127404 C17.5843692,7.78920673 18.8339846,7.1271875 20.1164846,6.5646875",
    id: "Fill-20",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76555,49.9775721 C7.64685769,51.1869471 8.63339615,52.3400721 9.68570385,53.4088221 L11.2575885,51.898726 C10.2776269,50.9078606 9.36562692,49.8347837 8.54351154,48.7097837 L6.76555,49.9775721 Z",
    id: "Fill-22",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61222308,42.0357212 C3.1033,43.450625 3.69960769,44.8374038 4.39237692,46.1571154 L6.33914615,45.16625 C5.69899231,43.9395673 5.14214615,42.6501442 4.68833846,41.3347596 L2.61222308,42.0357212 Z",
    id: "Fill-24",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3998923,59.6179567 L38.9128923,61.7208413 C40.3817385,61.372524 41.8374308,60.9073798 43.2383154,60.3448798 L42.4118154,58.3415144 C41.1117769,58.8629087 39.7613154,59.2934375 38.3998923,59.6179567",
    id: "Fill-26",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0241,60.69125 C22.4447154,61.2104808 23.9157538,61.6280288 25.3933692,61.9309135 L25.8384077,59.8128846 C24.4682154,59.5316346 23.1046,59.144375 21.7826385,58.6619231 L21.0241,60.69125 Z",
    id: "Fill-28",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0835615,56.3790385 C14.2871385,57.2833654 15.5674462,58.1076442 16.8894077,58.8280769 L17.9482923,56.9307212 C16.7184077,56.2622115 15.5301769,55.4985096 14.4142923,54.6569231 L13.0835615,56.3790385 Z",
    id: "Fill-30",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0204538,60.3574279 L29.8911077,62.5165625 C30.4830308,62.5511779 31.0771462,62.5663221 31.6778385,62.5663221 C32.6073769,62.5663221 33.5281462,62.5273798 34.4357615,62.4473317 L34.2384538,60.292524 C32.8529154,60.4136779 31.4191462,60.437476 30.0204538,60.3574279",
    id: "Fill-32",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4155308,44.3703125 L59.3929923,45.3027644 C60.0419154,43.9592548 60.5965692,42.5508413 61.0394154,41.1207933 L58.9413769,40.4890625 C58.5314154,41.8174279 58.0162231,43.1241587 57.4155308,44.3703125",
    id: "Fill-34",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3098577,30.360601 L60.1219346,30.4947356 C60.1592038,31.0831971 60.1767423,31.6803125 60.1767423,32.2795913 C60.1767423,33.6663702 60.0737038,35.0639663 59.8698192,36.431274 L62.0402038,36.744976 C62.2594346,35.2738221 62.36905,33.7723798 62.36905,32.2795913 C62.36905,31.6348798 62.3515115,30.9944952 62.3098577,30.360601",
    id: "Fill-36",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19230769,33.1705048 L1,33.2354087 C1.04603846,34.7346875 1.20607692,36.2339663 1.47353846,37.6943029 L3.63076923,37.3092067 C3.38303846,35.9527163 3.23615385,34.563774 3.19230769,33.1705048",
    id: "Fill-38",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1865308,56.4932692 L47.3046077,58.3538462 C48.6046462,57.5944712 49.8586462,56.73125 51.0293385,55.7901442 L49.6459923,54.1112981 C48.5586077,54.9853365 47.3944923,55.7858173 46.1865308,56.4932692",
    id: "Fill-40",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7119346,51.2557452 L54.3298577,52.7160817 C55.3492808,51.6170433 56.2963577,50.4293029 57.1425885,49.1939663 L55.3207808,47.9845913 C54.5381269,49.1333894 53.6612038,50.2324279 52.7119346,51.2557452",
    id: "Fill-42",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0439385,21.6781971 C51.3248615,20.3390144 50.4698615,19.0690625 49.5008615,17.9007933 L47.8040154,19.2724279 C48.6809385,20.3281971 49.4548231,21.4791587 50.1037462,22.6906971 L52.0439385,21.6781971 Z",
    id: "Fill-44",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6966308,32.2789423 L52.5043231,32.2789423 C52.5043231,33.6484135 52.3662077,35.024375 52.0943615,36.3635577 L54.2428231,36.7897596 C54.5453615,35.3077885 54.6966308,33.7912019 54.6966308,32.2789423",
    id: "Fill-46",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2396885,12.7253606 C26.5572654,12.3034856 27.9230731,12.0114183 29.3042269,11.855649 L29.0543038,9.70733173 C27.53065,9.87824519 26.0179577,10.200601 24.5622654,10.6679087 L25.2396885,12.7253606 Z",
    id: "Fill-48",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40969231,26.5048798 C9.02165385,27.9630529 8.78269231,29.4688221 8.69719231,30.9810817 L10.8851154,31.1022356 C10.9640385,29.7349279 11.1810769,28.3697837 11.5296538,27.0522356 L9.40969231,26.5048798 Z",
    id: "Fill-50",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4608423,11.8000481 C34.8441885,11.916875 36.2187654,12.1678365 37.5451115,12.5529327 L38.1633423,10.4760096 C36.6944962,10.0519712 35.1730346,9.77288462 33.6449962,9.64524038 L33.4608423,11.8000481 Z",
    id: "Fill-52",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0799962,52.8233894 C29.6900731,52.7844471 28.3023423,52.6092067 26.9584577,52.3019952 L26.4629962,54.4092067 C27.9515731,54.7510337 29.4839962,54.9435817 31.0208038,54.986851 L31.0799962,52.8233894 Z",
    id: "Fill-54",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3994077,14.0965625 C42.6227154,14.7347837 43.7868308,15.4984856 44.8632538,16.3681971 L46.2509846,14.6915144 C45.0627538,13.733101 43.7736769,12.889351 42.4232154,12.1840625 L41.3994077,14.0965625 Z",
    id: "Fill-56",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4273731,30.5211298 L54.6109115,30.3372356 C54.4815654,28.824976 54.1987577,27.3256971 53.7668731,25.8805048 L51.66445,26.4884375 C52.0524885,27.7951683 52.3089885,29.1516587 52.4273731,30.5211298",
    id: "Fill-58",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8734231,43.8822356 L50.6842692,45.1002644 C51.5524231,43.8454567 52.2934231,42.506274 52.8853462,41.1238221 L50.8684231,40.2800721 C50.3291154,41.5327163 49.6582692,42.7442548 48.8734231,43.8822356",
    id: "Fill-60",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1906962,47.017524 C45.1975808,47.9694471 44.1014269,48.8326683 42.9351192,49.5747356 L44.1255423,51.3898798 C45.4124269,50.5720913 46.6203885,49.6223317 47.7187346,48.5708894 L46.1906962,47.017524 Z",
    id: "Fill-62",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2349423,51.437476 C37.9458654,51.9329087 36.5997885,52.3006971 35.2317885,52.5365144 L35.6044808,54.6653606 C37.1149808,54.4079087 38.60575,54.0011779 40.03075,53.4538221 L39.2349423,51.437476 Z",
    id: "Fill-64",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3312462,46.1746394 C15.3929385,45.1686298 14.5532846,44.063101 13.8364,42.8926683 L11.9619769,44.0111779 C12.7534,45.3070913 13.6807462,46.5272837 14.7177077,47.6393029 L16.3312462,46.1746394 Z",
    id: "Fill-66",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0558077,39.1877404 C11.5910385,37.8939904 11.2556154,36.5548077 11.0626923,35.2048077 L8.89230769,35.5098558 C9.10496154,37.0004808 9.47546154,38.4846154 9.99284615,39.9125 L12.0558077,39.1877404 Z",
    id: "Fill-68",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0419038,16.7426923 C19.0898269,15.8448558 20.2320192,15.0487019 21.4377885,14.3758654 L20.3591731,12.4936538 C19.0240577,13.2378846 17.7612885,14.1184135 16.60375,15.1092788 L18.0419038,16.7426923 Z",
    id: "Fill-70",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9829346,23.2088462 C13.5945885,21.9843269 14.3355885,20.8117308 15.1840115,19.7278365 L13.4498962,18.4059615 C12.5115885,19.6023558 11.6916654,20.8982692 11.0186269,22.2547596 L12.9829346,23.2088462 Z",
    id: "Fill-72",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0237038,50.9790385 C21.7631269,50.4100481 20.5551654,49.7134135 19.4370885,48.9086058 L18.1436269,50.6566827 C19.3822808,51.5480288 20.7152038,52.3160577 22.1117038,52.945625 L23.0237038,50.9790385 Z",
    id: "Fill-74",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6774,29.03375 C29.8643615,29.03375 28.3889385,30.4897596 28.3889385,32.2789423 C28.3889385,34.068125 29.8643615,35.5241346 31.6774,35.5241346 C33.4904385,35.5241346 34.9658615,34.068125 34.9658615,32.2789423 C34.9658615,30.4897596 33.4904385,29.03375 31.6774,29.03375",
    id: "Fill-76",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6774,37.6875962 C28.6542077,37.6875962 26.1966308,35.2601923 26.1966308,32.2789423 C26.1966308,29.2976923 28.6542077,26.8702885 31.6774,26.8702885 C34.7005923,26.8702885 37.1581692,29.2976923 37.1581692,32.2789423 C37.1581692,35.2601923 34.7005923,37.6875962 31.6774,37.6875962 M31.6774,18.2164423 C23.8201692,18.2164423 17.4274,24.5250962 17.4274,32.2789423 C17.4274,40.0327885 23.8201692,46.3414423 31.6774,46.3414423 C39.5346308,46.3414423 45.9274,40.0327885 45.9274,32.2789423 C45.9274,24.5250962 39.5346308,18.2164423 31.6774,18.2164423",
    id: "Fill-78",
    fill: "#EFBBD4",
    className: "fill-dynamic-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.8330b9639a39411a6bee5ae2fd3032e0.svg";
export { ForwardRef as ReactComponent };